import {Injectable} from '@angular/core';
import {CryptoService} from './crypto.service';
import {BOOKING_WIDGET_LOCAL_STORAGE_CONSTANTS, LOCAL_STORAGE_CONSTANTS} from '@constants/local-storage.constants';
import {environment} from '../../../environments/environment';
import {LoggerService} from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class LocalstorageService {

  constructor(
    private cryptoService: CryptoService,
  ) {
  }

  setItem(key: string, value: string): void {
    const encryptedString = this.cryptoService.encryptValue(value);
    try {
      localStorage.setItem(key + '_' + environment.version, encryptedString);
    } catch (error) {
      LoggerService.warn(error);
    }
  }

  getItem(key: string): string {
    try {
      const encryptedPartner: string = localStorage.getItem(
        key + '_' + environment.version
      );
      if (encryptedPartner) {
        return this.cryptoService.decryptValue(encryptedPartner);
      }
    } catch (error) {
      LoggerService.warn(error);
    }
    return null;
  }

  removeItem(key: string): void {
    try {
      localStorage.removeItem(key + '_' + environment.version);
    } catch (error) {
      LoggerService.warn(error);
    }
  }

  /**
   * `refresh=1` clear for both modes. Never use a blanket localStorage.clear() — in WC mode
   * it would wipe the integrator website's own data. Booking keys need a prefix match (they
   * carry `<booking_name>_<version>` suffixes); the wk/csw_cat singletons use removeItem()
   * because a loose prefix could over-match an integrator's own keys.
   */
  clearWidgetKeys(): void {
    try {
      const prefixes = Object.values(BOOKING_WIDGET_LOCAL_STORAGE_CONSTANTS);
      const keysToRemove: string[] = [];
      for (let i = 0; i < localStorage.length; i++) {
        const storedKey = localStorage.key(i);
        if (storedKey && prefixes.some(prefix => storedKey.startsWith(prefix))) {
          keysToRemove.push(storedKey);
        }
      }
      keysToRemove.forEach(key => localStorage.removeItem(key));

      // Widget-owned singleton keys (exact `<name>_<version>` shape) — removeItem appends `_<version>`.
      this.removeItem(LOCAL_STORAGE_CONSTANTS.WORKERS_KEY);
      this.removeItem(LOCAL_STORAGE_CONSTANTS.CALENSO_AUTH_TOKEN);
    } catch (error) {
      LoggerService.warn(error);
    }
  }
}
